<template>
  <div>
    <!-- CONTACT US -->
    <section id="contact" class="section contact">
      <div class="container">
        <h2 class="text-center mb-5 light">تواصل معنا</h2>

        <div class="justify-content-center">
          <div class="social-links d-flex justify-content-center mb-4">
            <a target="_blank" href="https://wa.me/966565502202" class="mx-2 whatsapp">
              <i class="fa fa-whatsapp"></i>
            </a>
            <a target="_blank" href="https://twitter.com/Salatk3" class="mx-2 twitter">
              <i class="fa fa-twitter"></i>
            </a>
            <a
              target="_blank"
              href="https://www.facebook.com/profile.php?id=100041855266681"
              class="mx-2 facebook"
            >
              <i class="fa fa-facebook"></i>
            </a>
            <a target="_blank" href="https://www.instagram.com/salatk3" class="mx-2 instagram">
              <i class="fa fa-instagram"></i>
            </a>
          </div>

          <div class="form" dir="rtl">
            <form action method="post" role="form" class="contactForm">
              <div class="form-group">
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  id="name"
                  v-model="form.name"
                  placeholder="الاسم"
                  data-rule="minlen:4"
                  data-msg="Please enter at least 4 chars"
                />
                <div class="validation"></div>
              </div>
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  id="email"
                  v-model="form.email"
                  placeholder="الإيميل"
                  data-rule="email"
                  data-msg="Please enter a valid email"
                />
                <div class="validation"></div>
              </div>
              <div class="form-group">
                <textarea
                  class="form-control"
                  name="message"
                  rows="5"
                  v-model="form.message"
                  data-rule="required"
                  data-msg="Please write something for us"
                  placeholder="الرسالة"
                ></textarea>
                <div class="validation"></div>
              </div>

              <!-- RESULT MESSAGE -->
              <div v-if="message.text" :class="`alert alert-${message.success ? 'success' : 'danger'}`">
                {{ message.text }}
              </div>

              <div class="text-center">
                <button class="btn btn-light" type="submit" @click.prevent="send(form)">ارسال</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <p class="text-center m-0 py-2 text-white-50">AlexApps &copy; جميع الحقوق محفوظة</p>
    </footer>
  </div>
</template>


<script>
export default {
  name: 'contact-us',


  data: function () {
    return {
      form: {},

      message: {
        text: '',
        success: null,
      }
    }
  },


  methods: {
    send(form) {
      this.axios.post('/app/contact-us', form)
        .then(() => {
          this.message.success = true;
          this.message.text = 'تم ارسال الرسالة بنجاح';
          this.form = {}
        })
        .catch(() => {
          this.message.success = false;
          this.message.text = 'خطا اثناء ارسال الرسالة';
        })
    }
  }
}
</script>